import {Listener} from 'xstream'
import {curry} from 'ramda'

/**
 * STOP DEFAULT EVENT AND EVENT BUBBLE
 */
export const captureEvent = (e) => {
	e.stopPropagation();
	e.preventDefault();
	return e;
};
/**
 * stream event listener
 */
export const nop = _ => {}

export const log = curry( (label="",eventName="") => {
	return (param?:any) => {
		if( param && typeof param['toJS'] === 'function') param = param['toJS']()
		console.log( label,":",eventName,":",param );
	}
});	
/* DUMP & LISTEN */
export const dumper: <T>(label:string) => Listener<T> = (label) => {
	return {
		next: log( label,"next" ),
		error: log( label,"error"),
		complete: () => console.log(label,":complete")
	}
}
/* LISTEN QUIETLY */
export const nopListener: <T>(label:string) => Listener<T> = (label) => {
	return {
		next: nop,
		error: log( label,"error"),
		complete: () => console.log(label,":complete")
	}
}

export function num2FmtStr(fmtStr = ""): (number) => string {
		return function (n:number): string {
					const src = n + "";
					if( src.length >= fmtStr.length ) return src;
					return (fmtStr + n).slice( -1 * fmtStr.length );
				}
}
export const sepNum = num => {
	return ("" + num).replace(/(\d)(?=(\d{3})+$)/g, '$1,')
}
export const toJS = im => im.toJS()

export const fmt00 = num2FmtStr("00")
export const getDateTimeString = (dt = new Date()) => {
  return `${dt.getFullYear()}年${dt.getMonth() + 1}月${dt.getDate()}日 ${fmt00(
    dt.getHours(),
  )}時${fmt00(dt.getMinutes())}分`
}
